// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ETNU","row":"_3j4Mj","half":"GZ71N","textContainer":"_1Ha0X","textContainerCenter":"_1WitX"};